import withEntity from '@/entity/components/with-entity';

import FinancialFieldset from './financial-fieldset';

export default withEntity(FinancialFieldset);
